import { render, staticRenderFns } from "./GasContractView.vue?vue&type=template&id=25993a56&"
import script from "./GasContractView.vue?vue&type=script&lang=ts&"
export * from "./GasContractView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports